module.exports = __webpack_public_path__ + "05_hige_gray.48214f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/05_hige_gray.png
// module id = CFDI
// module chunks = 0